import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const MeetingsListPage = lazy(() => import('./MeetingsListPage'));
const MeetingDetailPage = lazy(() => import('./MeetingDetailPage'));

export const meetingRoutes: RouteObject[] = [
  {
    path: 'meetings',
    element: (
      <ProtectedRoute action="meetings:view">
        <MeetingsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'meetings/:id',
    element: (
      <ProtectedRoute action="meetings:view">
        <MeetingDetailPage />
      </ProtectedRoute>
    ),
  },
];
